/* eslint-disable max-len */
import React from 'react';

function ReceiptIcon() {
  return (
    <svg
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6276 1.201V19.7038C17.6276 20.6143 17.2587 21.4383 16.6621 22.0345C16.0659 22.6311 15.2415 23 14.3314 23H4.03424C2.93232 23 2.03906 22.1067 2.03906 21.0048V1.201C2.03906 1.20028 2.03906 1.19961 2.03906 1.19888C2.03929 1.05529 2.08989 0.915353 2.1781 0.802022C2.46407 0.434654 3.00457 0.294174 3.45333 0.572744C3.74873 0.756293 4.12214 0.758999 4.41978 0.579058L4.92804 0.272392C5.22884 0.0906469 5.56708 0 5.90576 0C6.2458 0 6.58629 0.0915489 6.88754 0.274647L6.9137 0.290431C7.51035 0.653018 8.26078 0.646705 8.85156 0.274647C9.15372 0.0924508 9.49375 0.00135294 9.83379 0.00135294C10.1738 0.00135294 10.5139 0.0924508 10.8156 0.274647C11.1173 0.457293 11.4573 0.548391 11.7974 0.548391C12.1374 0.548391 12.4774 0.457293 12.7791 0.274647C13.0826 0.0987645 13.4218 0.0108235 13.7605 0.0108235C14.1113 0.0108235 14.4622 0.105078 14.7734 0.293137L15.2257 0.56643C15.5328 0.751783 15.9171 0.751783 16.2237 0.56643C16.3838 0.469921 16.5543 0.425725 16.7212 0.425725C17.0258 0.425725 17.3159 0.572924 17.4975 0.814424C17.5807 0.925094 17.6274 1.06061 17.6276 1.19906V1.201Z"
        fill="url(#paint0_linear_19082_38)"
      />
      <path
        d="M17.6278 19.7038V13.9804H2.03906V21.6907C2.03906 22.4138 2.62525 23 3.34839 23H14.3316C15.2417 23 16.0661 22.6311 16.6623 22.0345C17.2589 21.4383 17.6278 20.6143 17.6278 19.7038Z"
        fill="url(#paint1_linear_19082_38)"
      />
      <path
        d="M10.8159 19.0201V19.7452C10.8159 21.5428 12.2732 23 14.0708 23H14.3314C14.479 23 14.6239 22.9893 14.7664 22.9706L10.8159 19.0201Z"
        fill="url(#paint2_linear_19082_38)"
      />
      <path
        d="M11.0355 19.704C11.0355 21.5243 12.5112 23 14.3315 23H3.29603C1.4757 23 0 21.5243 0 19.704C0 19.0116 0.561289 18.4503 1.25368 18.4503H9.78188C10.4742 18.4503 11.0355 19.0116 11.0355 19.704Z"
        fill="url(#paint3_linear_19082_38)"
      />
      <path
        d="M13.5642 14.3162H10.545C10.4975 14.3162 10.459 14.2776 10.459 14.2301V13.7257C10.459 13.6782 10.4975 13.6396 10.545 13.6396H13.5642C13.6117 13.6396 13.6502 13.6782 13.6502 13.7257V14.2301C13.6502 14.2776 13.6116 14.3162 13.5642 14.3162Z"
        fill="#8795DE"
      />
      <path
        d="M15.7289 15.624H10.545C10.4975 15.624 10.459 15.5855 10.459 15.5379V15.0335C10.459 14.986 10.4975 14.9475 10.545 14.9475H15.7289C15.7764 14.9475 15.8149 14.986 15.8149 15.0335V15.5379C15.8149 15.5855 15.7763 15.624 15.7289 15.624Z"
        fill="#8795DE"
      />
      <path
        d="M14.5563 16.9318H10.545C10.4975 16.9318 10.459 16.8933 10.459 16.8458V16.3414C10.459 16.2938 10.4975 16.2553 10.545 16.2553H14.5563C14.6038 16.2553 14.6424 16.2938 14.6424 16.3414V16.8458C14.6423 16.8933 14.6038 16.9318 14.5563 16.9318Z"
        fill="#8795DE"
      />
      <path
        d="M6.64343 13.066C5.01364 13.0117 3.68262 12.1697 3.68262 11.3004C3.68262 10.8386 4.09003 10.1595 4.60613 10.1595C5.17662 10.1595 5.63838 10.9608 6.64343 11.1374V8.93714C5.39386 8.46176 3.92705 7.87774 3.92705 6.13926C3.92705 4.4144 5.20377 3.5859 6.64343 3.3822V3.00193C6.64343 2.81175 6.86076 2.63519 7.15953 2.63519C7.41758 2.63519 7.67564 2.81175 7.67564 3.00193V3.34147C8.51766 3.36862 10.1068 3.5859 10.1068 4.52304C10.1068 4.88977 9.86234 5.63678 9.26466 5.63678C8.81652 5.63678 8.55847 5.20217 7.67564 5.1343V7.11721C8.91154 7.57897 10.3513 8.21737 10.3513 10.0508C10.3513 11.735 9.26471 12.7536 7.67564 13.0116V13.4055C7.67564 13.5957 7.41758 13.7723 7.15953 13.7723C6.86076 13.7723 6.64343 13.5957 6.64343 13.4055V13.066ZM6.77918 6.79129V5.17502C6.16806 5.29723 5.90996 5.60963 5.90996 5.93555C5.90996 6.32948 6.26312 6.57391 6.77918 6.79129ZM7.53989 9.30383V11.1238C8.0016 11.0152 8.36834 10.7571 8.36834 10.2682C8.36829 9.81993 8.02875 9.53473 7.53989 9.30383Z"
        fill="url(#paint4_linear_19082_38)"
      />
      <path
        d="M12.956 3.59388V6.75628C12.956 6.81541 12.9047 6.86335 12.8413 6.86335H12.3358C12.2725 6.86335 12.2212 6.81541 12.2212 6.75628V3.59388C12.2212 3.53476 12.2725 3.48682 12.3358 3.48682H12.8413C12.9047 3.48682 12.956 3.53476 12.956 3.59388Z"
        fill="url(#paint5_linear_19082_38)"
      />
      <path
        d="M14.8165 3.59388V6.75628C14.8165 6.81541 14.7652 6.86335 14.7019 6.86335H14.1962C14.1329 6.86335 14.0815 6.81541 14.0815 6.75628V3.59388C14.0815 3.53476 14.1329 3.48682 14.1962 3.48682H14.7019C14.7652 3.48682 14.8165 3.53476 14.8165 3.59388Z"
        fill="url(#paint6_linear_19082_38)"
      />
      <path
        d="M15.815 3.59388V6.75628C15.815 6.81541 15.7637 6.86335 15.7004 6.86335H15.1947C15.1314 6.86335 15.0801 6.81541 15.0801 6.75628V3.59388C15.0801 3.53476 15.1314 3.48682 15.1947 3.48682H15.7004C15.7637 3.48682 15.815 3.53476 15.815 3.59388Z"
        fill="url(#paint7_linear_19082_38)"
      />
      <path
        d="M11.0192 3.59388V6.75628C11.0192 6.81541 10.9679 6.86335 10.9046 6.86335H10.5311C10.4678 6.86335 10.4165 6.81541 10.4165 6.75628V3.59388C10.4165 3.53476 10.4678 3.48682 10.5311 3.48682H10.9046C10.9679 3.48682 11.0192 3.53476 11.0192 3.59388Z"
        fill="url(#paint8_linear_19082_38)"
      />
      <path
        d="M11.8732 3.59388V6.75628C11.8732 6.81541 11.8219 6.86335 11.7586 6.86335H11.3851C11.3218 6.86335 11.2705 6.81541 11.2705 6.75628V3.59388C11.2705 3.53476 11.3218 3.48682 11.3851 3.48682H11.7586C11.8219 3.48682 11.8732 3.53476 11.8732 3.59388Z"
        fill="url(#paint9_linear_19082_38)"
      />
      <path
        d="M13.7896 3.59388V6.75628C13.7896 6.81541 13.7382 6.86335 13.6749 6.86335H13.3017C13.2383 6.86335 13.187 6.81541 13.187 6.75628V3.59388C13.187 3.53476 13.2383 3.48682 13.3017 3.48682H13.6749C13.7382 3.48682 13.7896 3.53476 13.7896 3.59388Z"
        fill="url(#paint10_linear_19082_38)"
      />
      <path
        d="M12.2212 6.37054V6.75613C12.2212 6.81521 12.2726 6.86347 12.3357 6.86347H12.7141L12.2212 6.37054Z"
        fill="url(#paint11_linear_19082_38)"
      />
      <path
        d="M10.417 6.75615C10.417 6.81523 10.468 6.86348 10.5315 6.86348H10.905C10.9681 6.86348 11.0195 6.81523 11.0195 6.75615V5.1687L10.417 4.56619V6.75615Z"
        fill="url(#paint12_linear_19082_38)"
      />
      <path
        d="M11.2705 6.75614C11.2705 6.81522 11.3219 6.86348 11.3855 6.86348H11.7589C11.8221 6.86348 11.8735 6.81522 11.8735 6.75614V6.02285L11.2705 5.41989V6.75614Z"
        fill="url(#paint13_linear_19082_38)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19082_38"
          x1="0.527199"
          y1="2.81876"
          x2="22.9849"
          y2="23.5177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFCFC" />
          <stop offset="0.2575" stopColor="#EBF3FF" />
          <stop offset="0.7423" stopColor="#B8C4ED" />
          <stop offset="1" stopColor="#A2AEE6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19082_38"
          x1="9.83348"
          y1="15.9046"
          x2="9.83348"
          y2="22.8528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7BACDF" stopOpacity="0" />
          <stop offset="1" stopColor="#7BACDF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19082_38"
          x1="15.6079"
          y1="24.8487"
          x2="11.0122"
          y2="20.253"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8795DE" stopOpacity="0" />
          <stop offset="0.4678" stopColor="#7D8DDC" stopOpacity="0.468" />
          <stop offset="1" stopColor="#6C7FD8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_19082_38"
          x1="7.16579"
          y1="18.7608"
          x2="7.16579"
          y2="23.3192"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF6FF" />
          <stop offset="0.2575" stopColor="#DCE8FA" />
          <stop offset="0.7423" stopColor="#B8C4ED" />
          <stop offset="1" stopColor="#A2AEE6" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_19082_38"
          x1="3.68262"
          y1="8.20375"
          x2="10.3513"
          y2="8.20375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A2E62E" />
          <stop offset="1" stopColor="#02905D" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_19082_38"
          x1="11.7847"
          y1="3.11927"
          x2="13.0669"
          y2="6.3983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#3E5959" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_19082_38"
          x1="13.4137"
          y1="2.52731"
          x2="14.6959"
          y2="5.80634"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#3E5959" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_19082_38"
          x1="14.2881"
          y1="2.20978"
          x2="15.5702"
          y2="5.4888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#3E5959" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_19082_38"
          x1="10.1472"
          y1="3.71569"
          x2="11.4282"
          y2="6.99169"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#3E5959" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_19082_38"
          x1="10.895"
          y1="3.44424"
          x2="12.176"
          y2="6.72025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#3E5959" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_19082_38"
          x1="12.5733"
          y1="2.83511"
          x2="13.8543"
          y2="6.11116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#537983" />
          <stop offset="1" stopColor="#3E5959" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_19082_38"
          x1="13.6669"
          y1="8.03015"
          x2="10.1936"
          y2="4.55689"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#384949" stopOpacity="0" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_19082_38"
          x1="13.2159"
          y1="8.48133"
          x2="9.74259"
          y2="5.00802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#384949" stopOpacity="0" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_19082_38"
          x1="13.4292"
          y1="8.26783"
          x2="9.9559"
          y2="4.79456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#384949" stopOpacity="0" />
          <stop offset="1" stopColor="#384949" />
        </linearGradient>
      </defs>
    </svg>
  );
}

ReceiptIcon.propTypes = {};

export default ReceiptIcon;
